<template>
  <section class='content'>
    <div class="modal fade" id="queryModal" tabindex="-1" role="dialog" aria-labelledby="queryModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title" id="forgot_ModalLabel"><i class="fa fa-database mr-5"></i>SQL</h4>
          </div>
          <div class="modal-body text-center">
            <p><strong>SKU:</strong><br/>{{JSON.parse(query).sku}}</p>
            <p><strong>EAN:</strong><br/>{{JSON.parse(query).ean}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Abbrechen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="payloadModal" tabindex="-1" role="dialog" aria-labelledby="payloadModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-database mr-5"></i>Information</h4>
          </div>
          <div class="modal-body">
            <p v-if="information.payload"><strong>Payload:</strong><br/> <pre>{{information.payload}}</pre></p>
            <p><strong>Result:</strong><br/><pre>{{information.message}}</pre></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Abbrechen</button>
          </div>
        </div>
      </div>
    </div>
    <cancel-modal @action="cancelOrder" :reason="cancelReason" v-model="cancelReason"></cancel-modal>
    <div class="row">
      <monitoring-table :loading="loading" :type="'order'" :items="failed" @query="update($event)" @alert="notify($event)" @deleteRow="removeRow($event, failed)"></monitoring-table>
    </div>
    <div class="row">
      <monitoring-table :loading="loading" :type="'merchant'" :items="canceled" @query="update($event)" @alert="notify($event)" @deleteRow="removeRow($event, canceled)"></monitoring-table>
    </div>
  </section>
</template>
<script>
import MonitoringComponent from '../../tools/MonitoringComponent.vue'
import MonitoringTableComponent from '../../tools/Tables/MonitoringTableComponent.vue'

export default {
  data () {
    return {
      items: [],
      loading: true,
      loadingRows: false,
      canceled: [],
      failed: [],
      cancelReason: 'out_of_stock',
      lineForCancel: 0,
      typeForCancel: '',
      query: '{}',
      selectedArray: '',
      alerts: [],
      information: {
        message: {
        },
        payload: {
        }
      },
      running: false
    }
  },
  components: {
    monitoring: MonitoringComponent,
    monitoringTable: MonitoringTableComponent
  },
  methods: {
    update (value) {
      this.query = value
    },
    removeRow (value, array) {
      value.showSecondRow = false
      array.splice(array.indexOf(value), 1)
    },
    deleteRow (array) {
      this.loadingRows = true
      this.lineForCancel = array.id
      this.selectedArray = array.type
    },
    notify (value) {
    	this.alerts = []
      this.alerts.push({dismiss: 4, type: value[0], message: value[1], icon: value[2], show: true})
    },
    selectEvent (value) {
      this.information = ''
      this.information = value
    },
    openCancelModal (obj) {
      $('#cancelModal').modal('show')
      this.lineForCancel = obj.id
      this.typeForCancel = obj.type
    },
    cancelOrder (reason) {
      this.loading = true
      if (this.typeForCancel === 'merchant') {
        this.canceled = this.canceled.filter(e => {
          return e.order_item_line_id !== this.lineForCancel
        })
      } else {
        this.failed = this.failed.filter(e => {
          return e.order_item_line_id !== this.lineForCancel
        })
      }
      API.put(`orders/line/${this.lineForCancel}/cancel`, {reason: reason[0], message: reason[1]})
        .then(response => {
          $('#cancelModal').click()
          this.loading = false
          this.$store.commit('pushAlert',{dismiss: 4, type: 'success', message: 'Line cancelled successfully', icon: 'fa fa-check', show: true})
        })
        .catch(error => {
          $('#cancelModal').click()
          this.loading = false
          this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error.response.data.message, icon: 'fa fa-ban', show: true})
        })
    }
  },
  mounted () {
    API.all([API.get('monitoring/order/failed'), API.get('monitoring/order/canceled')])
      .then(API.spread((failed, canceled) => {
        failed.data.forEach(f =>{
          f.showSecondRow = false
          f.rows = []
          this.failed.push(f)
        })
        canceled.data.forEach(c => {
          c.showSecondRow = false
          c.rows = []
          this.canceled.push(c)
        })
        this.loading = false
      }))
      .catch(error => {
        this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error.response.data.message, icon: 'fa fa-ban', show: true})
      })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/Monitoring/Errors.vue